var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-record-found no-screening-hits"},[_c('div',{staticClass:"middle-align"},[_c('div',{staticClass:"no-record-image"},[_c('div',{staticClass:"check-hits"},[_c('i',{staticClass:"icon-tick-with-circle"})])]),_c('p',[_vm._v("No Name Screening Hits")])])])
}]

export { render, staticRenderFns }